import { render, staticRenderFns } from "./_Table.vue?vue&type=template&id=19f25262&scoped=true&"
import script from "./_Table.vue?vue&type=script&lang=js&"
export * from "./_Table.vue?vue&type=script&lang=js&"
import style0 from "./_Table.vue?vue&type=style&index=0&id=19f25262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f25262",
  null
  
)

export default component.exports